import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as MessageActions from '../_actions/message';
import { Message } from '../_models';

export interface MessageState extends EntityState<Message> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Message> = createEntityAdapter<Message>();

const initialState: MessageState = adapter.getInitialState({
  loading: false,
  error: null,
});

const messageReducer = createReducer(
  initialState,

  on(MessageActions.loadMessages, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(MessageActions.loadMessagesSuccess, (state, { messages }) =>
    adapter.setAll(messages, { ...state, loading: false })
  ),

  on(MessageActions.loadMessagesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MessageActions.addMessageSuccess, (state, { message }) => adapter.addOne(message, state)),

  on(MessageActions.updateMessageSuccess, (state, { message }) =>
    adapter.upsertOne(message, state)
  ),

  on(MessageActions.deleteMessageSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    MessageActions.addMessageFailure,
    MessageActions.updateMessageFailure,
    MessageActions.deleteMessageFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: MessageState | undefined, action: Action) {
  return messageReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
